import moment from "moment";
import { IEmail } from "../../../../Interfaces/Geral/Triagem";
import Table from "../../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilter, faTrash } from "@fortawesome/free-solid-svg-icons";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ListarClienteEmailTriagemController } from "../../../../Controllers/Geral/Email/EmailController";
import { ITriagem } from "../../../../Interfaces/Geral/Email/EmailInterface";
import { FormProvider, useForm } from "react-hook-form";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { DesvincularClienteEmailTriagemController } from "../../../../Controllers/Geral/Triagem/TriagemControllers";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import Swal from "sweetalert2";
import { useState } from "react";
import { IComponentModal } from "../../../Modais/IModalComponent";
import ModalComponent from "../../../Modais";
import EmailsRespostas from "./EmailsRespostas";

const todaysDate = new Date();
//instancia um objeto date de 3 meses antes da data de hoje
const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
const filtroInicial: ITriagem = {
    DT_CADASTRO_INICIO: pastDate.toISOString().substring(0, 10),
    DT_CADASTRO_FIM: todaysDate.toISOString().substring(0, 10),
    DS_REMETENTE: "",
    DS_ASSUNTO: "",
    ID_PRODUTO: [],
    ID_CONTATO: 0,
    ID_EMAIL_CONTA: 0,
    ID_USUARIO: 0,
    PAGINA: 1,
};

interface IHistoricoEmailsCliente {
    ID_USUARIO: number;
}

export default function HistoricoEmailsCliente(props: IHistoricoEmailsCliente) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const FILTRO_TRIAGEM = sessionStorage.getItem("HISTORICO_EMAILS_CLIENTE");
    const FormMethods = useForm();

    const { setPage, filter, setFilter, page } = usePaginationFilter<ITriagem>({
        page: 1,
        filter: FILTRO_TRIAGEM ? JSON.parse(FILTRO_TRIAGEM) : filtroInicial,
    });

    const { handleSubmit, register } = FormMethods;

    const {
        execute: DesvincularClienteEmailTriagem,
        loading: DesvincularClienteEmailTriagemLoading,
    } = useAsyncCallback(DesvincularClienteEmailTriagemController);

    const {
        value: lstClienteEmailTriagem,
        loading: lstClienteEmailTriagemLoading,
        execute: ListarClienteEmailTriagem,
    } = useAsyncEffect(async () => {
        return ListarClienteEmailTriagemController(
            props.ID_USUARIO,
            0,
            filter ? { ...filter, PAGINA: page } : filtroInicial
        );
    }, [filter, page, props.ID_USUARIO]);

    const totalPaginas = lstClienteEmailTriagem?.NR_TOTAL_PAGINAS || 1;

    const handleFilter = (formData: ITriagem) => {
        const filterFormData: ITriagem = {
            DT_CADASTRO_INICIO:
                formData.DT_CADASTRO_INICIO || filtroInicial.DT_CADASTRO_INICIO,
            DT_CADASTRO_FIM:
                formData.DT_CADASTRO_FIM || filtroInicial.DT_CADASTRO_FIM,
            DS_ASSUNTO: "",
            DS_REMETENTE: "",
            ID_CONTATO: 0,
            ID_EMAIL_CONTA: 0,
            ID_PRODUTO: [],
            ID_USUARIO: props.ID_USUARIO,
            PAGINA: 1,
        };
        setFilter(filterFormData);
        sessionStorage.setItem(
            "HISTORICO_EMAILS_CLIENTE",
            JSON.stringify(filterFormData)
        );
        setPage(1);
    };

    function row(cell: any, row: IEmail) {
        return (
            <div className="d-flex flex-wrap justify-content-between p-4 my-1">
                <div className="d-flex">
                    <div className="mr-2">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="historico-tooltip">
                                    Visualizar respostas
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-info"
                                onClick={() => {
                                    setModal({
                                        Component: () => (
                                            <EmailsRespostas
                                                setShow={setShow}
                                                ID_EMAIL={row.ID_EMAIL}
                                            />
                                        ),

                                        headerComponent: "Respostas do Email",
                                        IconHeader: faEye,
                                        size: "xl",
                                    });
                                    setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                        </OverlayTrigger>
                    </div>
                    <div className="d-flex flex-column">
                        <h4 className="mb-0">{row.DS_ASSUNTO}</h4>
                        <h5 className="text-muted">{row.DS_REMETENTE}</h5>
                    </div>
                </div>
                <div className="mb-2 mr-5 d-flex justify-content-center">
                    <div
                        className="d-flex flex-column mr-2"
                        style={{
                            width: "200px",
                        }}
                    >
                        <div className="font-weight-bold mb-1">
                            Data de envio
                        </div>
                        <div
                            className="text-primary font-weight-bold text-center px-2 rounded"
                            style={{
                                backgroundColor: "#e1f0ff",
                            }}
                        >
                            {moment(row.DT_CADASTRO).format("lll")}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-auto">
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                                Swal.fire({
                                    title: "Deseja desvincular este email?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        DesvincularClienteEmailTriagem(
                                            row.ID_EMAIL
                                        ).then(() => {
                                            ListarClienteEmailTriagem();
                                        });
                                    }
                                });
                            }}
                            disabled={DesvincularClienteEmailTriagemLoading}
                        >
                            {DesvincularClienteEmailTriagemLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faTrash} />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_REMETENTE",
            text: "Emails",
            formatter: row,
        },
    ];

    return (
        <div className="card card-body">
            <FormProvider {...FormMethods}>
                <form
                    className="d-flex flex-wrap justify-content-end align-items-center mb-3"
                    onSubmit={handleSubmit(handleFilter)}
                >
                    <div className="mr-3">
                        <label>Data de Início</label>
                        <input
                            className="form-control"
                            type="date"
                            name="DT_CADASTRO_INICIO"
                            defaultValue={filter?.DT_CADASTRO_INICIO}
                            ref={register()}
                        />
                    </div>
                    <div className="mr-3">
                        <label>Data de Fim</label>
                        <input
                            className="form-control"
                            type="date"
                            name="DT_CADASTRO_FIM"
                            defaultValue={filter?.DT_CADASTRO_FIM}
                            ref={register()}
                        />
                    </div>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="ver-info-tooltip">Filtrar</Tooltip>
                        }
                    >
                        <button
                            type="submit"
                            className="btn btn-outline-dark mt-auto"
                        >
                            <FontAwesomeIcon icon={faFilter} />
                        </button>
                    </OverlayTrigger>
                </form>
            </FormProvider>

            <Table
                columns={columns}
                keyField="ID_EMAIL"
                data={lstClienteEmailTriagem?.LISTA_EMAILS ?? []}
                sizePerPage={10}
                loading={lstClienteEmailTriagemLoading}
                noSearch
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
            />
            <ModalComponent
                setShow={setShow}
                show={show}
                ModalComponent={modal}
            />
        </div>
    );
}
